import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

import { TableConfig } from "src/app/models/custom-table/custom-table.model";

export const OPTIONS_FILTER_FORM = {
  option: "option",
};

@Component({
  selector: "app-options-filter",
  templateUrl: "./options-filter.component.html",
  styleUrls: ["./options-filter.component.scss"],
})
export class OptionsFilterComponent implements OnInit, OnDestroy {

  @Input() optionField: string = '';
  @Input() optionsList: { code: string; description: string }[] = [];
  @Input() tableConfig: TableConfig[] = [];

  @Output() public optionSelected: EventEmitter<any> = new EventEmitter();
  
  fieldLabel: string = '';
  optionsFilterFormGroup: FormGroup;

  constructor(public fb: FormBuilder) { }

  ngOnInit(): void {
    this.setFieldLabel();
    this.createOptionsFilterForm();
  }

  setFieldLabel() {
    this.fieldLabel = this.tableConfig.find((config) => config.field === this.optionField)?.header || '';
  }

  createOptionsFilterForm() {
    this.optionsFilterFormGroup = this.fb.group({
      [OPTIONS_FILTER_FORM.option]: [null],
    });
    this.onOptionChanges(this.optionsFilterFormGroup);
  }

  onOptionChanges(form: FormGroup) {
    form.get(OPTIONS_FILTER_FORM.option).valueChanges.subscribe((option) => {
      this.optionSelected.emit(option);
    });
  }

  clearFormControl(form: FormGroup, formControl: string): void {
    if (!form.controls[formControl].value) {
      return;
    }
    form.controls[formControl].setValue(null);
  }

  ngOnDestroy(): void {

  }
}
